var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlayReset = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0C1.55 0 2 0.45 2 1V11C2 11.55 1.55 12 1 12C0.45 12 0 11.55 0 11V1C0 0.45 0.45 0 1 0ZM4.66 6.82L10.43 10.89C11.09 11.36 12.01 10.88 12.01 10.07V1.93C12.01 1.12 11.1 0.65 10.43 1.11L4.66 5.18C4.09 5.58 4.09 6.42 4.66 6.82Z",
    fill: "#E5E4EC"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlayReset);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/play-reset.691facea5a71f68b5954b84eb0d3dbd9.svg";